<template>
  <div class="target-selector-actions" part="actions">
    <sp-button
      v-for="action in actions"
      :key="action.key"
      variant="appearance-link"
      size="x-small"
      @click="emit('activate', action.key)"
      >{{ action.label }}</sp-button
    >
  </div>
</template>

<script setup>
const emit = defineEmits(["activate"]);

defineProps({
  /**
   * @type {Array<{key: String, label: String}>}
   */
  actions: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
// The pane's first slotted row is its field label, and the actions sit on that row.
.target-selector-actions {
  display: flex;
  gap: var(--sp-ref-scale-6);
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
